
import React, { useEffect, useState } from 'react';
import './index.css'
import { TicketMultipleCloseFormModel } from '../../../../models/ticket.model';
import { useProject } from '../../../../context/ProjectContext';
import Autocomplete from '../../../common/Autocomplete';
import RichEditor from '../../../common/RichEditor';
import FormSection, { FormElement } from '../../../common/FormSection';
import { getClosingCauses } from '../../../../services/autocomplete.service';
import { itemSelection } from '../../../../models/itemSelection.model';
import { useNotification } from '../../../../context/NotificationContext';


interface TicketCloseMultipleProps {
  setLoadingData: (p: boolean) => void
  ticketMultipleCloseForm: TicketMultipleCloseFormModel
  setTicketMultipleCloseForm: (p: any) => void
  action: string
  setConfirmDisabled?: (p: boolean) => void
}

const TicketCloseMultiple: React.FC<TicketCloseMultipleProps> = ({
  setLoadingData,
  ticketMultipleCloseForm,
  setTicketMultipleCloseForm,
  action,
  setConfirmDisabled,
}) => {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const requiredFields: (keyof TicketMultipleCloseFormModel)[] = ['closing_cause']
  const [closingCausesList, setClosingCausesList] = useState([]);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketMultipleCloseForm({
      ...ticketMultipleCloseForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setTicketMultipleCloseForm({
      ...ticketMultipleCloseForm,
      [key]: value
    });
  }

  const initComponent = () => {
    if (action === "create") {
      setLoadingData(true)
      Promise.all([
        getClosingCauses(selectedProject),
      ]).then(function (result) {
        setClosingCausesList(result[0])
        setLoadingData(false)
      }).catch((error) => {
        setLoadingData(false)
        showNotification(error.response.data)
      });
    }
  };

  useEffect(initComponent, [])

  const formHasErrors = (): boolean => {
    const validation = requiredFields.some((key) =>
      !ticketMultipleCloseForm[key] ||
      Object.keys(ticketMultipleCloseForm[key]).length === 0 ||
      !(ticketMultipleCloseForm[key] as itemSelection).id)

    setConfirmDisabled && setConfirmDisabled(validation)

    return validation
  }

  return (
    <React.Fragment>
      <div className='multiple-action-modal-section'>
        <FormSection>
          <FormElement>
            <div className='tkt-form-section'>
              <div className='tkt-form-section-title'>
                <p>DATOS BÁSICOS</p>
              </div>

              <div className='tkt-form-section-item'>
                <Autocomplete
                  label='Causa de Cierre'
                  placeholder='Causa de Cierre'
                  name='closing_cause'
                  disabled={action === "view"}
                  options={closingCausesList}
                  value={ticketMultipleCloseForm.closing_cause}
                  handleSelection={handleSelection}
                  required
                />
              </div>

            </div>
          </FormElement>
          <FormElement>

            <div className='tkt-form-section'>
              <div className='tkt-form-section-title'>
                <p>DESCRIPCIÓN</p>
              </div>
              <div className='tkt-form-section-item__desc'>
                <RichEditor
                  name="description"
                  value={ticketMultipleCloseForm.description}
                  disabled={action === "view"}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </FormElement>

          <div className='ticket-form-confirm-section'>
            <div className='text-secondary'>
              <p>
                (*) Campos requeridos
              </p>
            </div>

            {formHasErrors()}


          </div>

        </FormSection>

      </div>
    </React.Fragment>
  )
}


export default TicketCloseMultiple